module.exports = __webpack_public_path__ + "img/neon-circle-logo.5f50af97.png";